import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const selectedParcelsSlice = createSlice({
  name: 'selectedParcels',
  initialState,
  reducers: {
    onSelectParcel(state, action) {
      const { parcelCode } = action.payload;
      if (state[parcelCode]) {
        // Remove the parcel if it is already selected
        delete state[parcelCode];
      } else {
        // Add the parcel to the selected list
        state[parcelCode] = action.payload;
      }
    },
    onSelectParcels(state, action) {
      action.payload.forEach((parcel) => {
        state[parcel.parcelCode] = parcel;
      });
    },
    resetSelectedParcels() {
      return initialState;
    },
  },
});

export const { onSelectParcel, onSelectParcels, resetSelectedParcels } =
  selectedParcelsSlice.actions;

export default selectedParcelsSlice.reducer;
